import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { QuizState } from './state/quiz.state';
import { QuizLabelAnatomySelectComponent } from './components/quiz-label-anatomy-select/quiz-label-anatomy-select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../shared/components/icon/icon.module';

@NgModule({
  declarations: [QuizLabelAnatomySelectComponent],
  exports: [QuizLabelAnatomySelectComponent],
  imports: [NgxsModule.forFeature([QuizState]), CommonModule, IconModule, ReactiveFormsModule],
})
export class QuizModule {}
